export enum CookieCategory {
    necessary = 'cookie_cat_necessary',
    functional = 'cookie_cat_functional',
    statistic = 'cookie_cat_statistic',
    marketing = 'cookie_cat_marketing',
    unclassified = 'cookie_cat_unclassified'
}
